'use es6';

import { get } from '../../retrieve/inboundDb/pipelines';
import { makeOption } from '../Option';
export const generatePipelineLabel = pipelineObject => pipelineObject.get('label');
export default (type => () => get(type).then(pipelines => pipelines.map(({
  pipelineId,
  label
}) => makeOption(pipelineId, label))));